import React from "react";
import styles from "./AddCreditPayGoFormView.module.scss";
import InputCode from "../../../../../common/components/atom/InputCode/InputCode";
import { DataFormAddPayGoCredit, ErrorStatus } from "./AddCreditPaygoForm";
import MessageCard from "../../../../../common/components/molecule/MessageCard/MessageCard";
import Button from "../../../../../common/components/atom/Button/Button";
import { numberFormaterString } from "../../../../../utils/numberFormater";

export interface AddCreditPayGoFormViewProps {
  selectStationInputRender?: () => React.JSX.Element;
  dataForm?: DataFormAddPayGoCredit;
  setDataForm?: (key: keyof DataFormAddPayGoCredit, value: any) => void;
  payGoCreditDecryptedValue?: string | number;
  isLoading?: boolean;
  submitLabel?: string;
  description?: string;
  title?: string;
  maxWidth?: string;
  handleSubmit?: () => void;
  messageError?: string | null;
  errorStatus?: ErrorStatus;
  disableSubmit?: boolean;
  paygoDecryptedRender?: () => React.JSX.Element;
}

export default function AddCreditPayGoFormView({
  dataForm,
  setDataForm,
  selectStationInputRender,
  submitLabel = "Ajouter le crédit",
  description = "Saisissez les informations du paygo Crédit",
  maxWidth = "700px",
  isLoading,
  handleSubmit,
  title,
  messageError,
  errorStatus,
  disableSubmit = false,
  paygoDecryptedRender,
}: AddCreditPayGoFormViewProps) {
  return (
    <>
      <div style={{ maxWidth: maxWidth }}>
        <div className={[styles["container"]].join(" ")}>
          {title && (
            <h1 className={[styles["container__title"]].join(" ")}>{title}</h1>
          )}
          <p className={[styles["container__description"]].join(" ")}>
            {description}
          </p>
          <div className={[styles["container__error-message"]].join(" ")}>
            <MessageCard variant="danger" message={messageError || errorStatus?.message} width100 />
          </div>
          <form
            className={[styles["form"]].join(" ")}
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit && handleSubmit();
            }}
          >
            {selectStationInputRender && (
              <div className={[styles["form__item"]].join(" ")}>
                {selectStationInputRender()}
              </div>
            )}
            <div className={[styles["form__item"]].join(" ")}>
              <InputCode
                value={dataForm?.paygoCode}
                onChange={(value) => {
                  if (setDataForm) {
                    setDataForm("paygoCode", value);
                  }
                }}
                label="PayGo Code"
                isError={errorStatus?.isErrorPaygoCode}
              />
            </div>

            {paygoDecryptedRender && (
              <div className={[styles["form__item"]].join(" ")}>
                {paygoDecryptedRender()}
              </div>
            )}
            <div className={[styles["form__button-container"]].join(" ")}>
              <div
                className={[styles["form__button-container__item"]].join(" ")}
              >
                <Button
                  isLoading={isLoading}
                  onClick={handleSubmit}
                  type={"submit"}
                  disabled={disableSubmit || isLoading}
                >
                  {submitLabel}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export interface PayGoCreditDecryptedProps {
  amountCredit?: number;
  currency? : string;
}

export const PayGoCreditDecryptedView = ({amountCredit, currency}: PayGoCreditDecryptedProps) => {
  return (<div className={[styles["paygo-credit-decrypted"]].join(" ")}>
    <p className={[styles["paygo-credit-decrypted__title"]].join(" ")}>
      Ce PayGo contient un crédit de {numberFormaterString(amountCredit || 0)} {currency}
    </p>
  </div>)
}
